import React from "react";
import { DatePicker, Form, Input, Select } from "antd";
import moment from "moment";
import { useSelector } from "react-redux";
import { requiredFeilds, getErrorText } from "../utils";

import { useLabsStock } from "../context/LabsStockContext";

const { Option } = Select;
const { TextArea } = Input;

const EditableCell = ({
  cell,
  isRevisionUpdateCase,
  dueDateRequired,
  type,
}) => {
  const {
    expandedRowKeys,
    setExpandedRowKeys,
    images,
    setImages,
    attachPopupVisible,
    setAttachPopupVisible,
    currentUpdateObj,
    fields,
    setFields,
    getColumnName,
  } = useLabsStock();

  const {
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  } = cell;

  let inputNode;

  //   let classname = `${isRevisionUpdateCase ? "ims-doc-readonly-input" : ""}`;

  let isRequired = [...requiredFeilds];
  dueDateRequired && isRequired.push("document_due_date");

  return (
    <td {...restProps}>
      {editing ? (
        dataIndex === "stop_time" ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: ``,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  let startTime = getFieldValue("start_time");
                  const isBefore = moment(startTime).isBefore(
                    value,
                    "milliseconds"
                  );
                  if (isBefore) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(""));
                },
              }),
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          <Form.Item
            className={`ims-doc-first-level`}
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[
              {
                required: isRequired.includes(dataIndex),
                message: getErrorText(dataIndex),
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        )
      ) : (
        children
      )}
    </td>
  );
};

export default EditableCell;
